import Markdown from '../../../../ui/Markdown/Markdown';
import ExpandableSection from '../ExpandableSection/ExpandableSection';
import css from './ExpandableProductAdditionalInfo.css';

interface ExpandableProductAdditionalInfoProps {
  heading: string;
  additionalInfo?: string;
  className?: string;
}

const ExpandableProductAdditionalInfo = ({
  additionalInfo,
  className,
  heading,
}: ExpandableProductAdditionalInfoProps) => {
  if (!additionalInfo) {
    return null;
  }

  return (
    <ExpandableSection className={className} heading={heading}>
      {() => <Markdown className={css.content} content={additionalInfo} />}
    </ExpandableSection>
  );
};

export default ExpandableProductAdditionalInfo;
